module.exports = __webpack_public_path__ + "assets/img/website_preview_3.d36a0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/website_preview_3.png
// module id = 53
// module chunks = 0